import { cn } from '@invent/wl-ui-kit-next';
import { ExternalLink } from 'lucide-react';
import * as React from 'react';
import { Link } from 'react-router-dom';

/**
 * A link that opens its page in a new browser tab (SR-491; Conga's *View*), so a list stays where it
 * was and the reader toggles between the two: `target="_blank"`, `rel="noopener"`, and an arrow
 * that says so. `label` is its accessible name — "Open Ann Hall in a new tab" — and its tooltip;
 * with no children the arrow is all that is drawn.
 */
export function NewTabLink({
  to,
  label,
  className,
  children
}: {
  to: string;
  label: string;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <Link
      to={to}
      target="_blank"
      rel="noopener"
      aria-label={label}
      title={label}
      data-new-tab=""
      className={cn(
        'inline-flex items-center gap-1 rounded px-0.5 font-medium text-[var(--color-sapphire)] outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring',
        className
      )}
    >
      {children}
      <ExternalLink className="size-3.5 shrink-0" aria-hidden />
    </Link>
  );
}
